import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import CircularProgress from "@mui/material/CircularProgress";
const ButtonLoadingAnimation = ({
  classes,
  loading,
  color
}) => {
  if (loading) {
    return /*#__PURE__*/React.createElement(CircularProgress, {
      size: 24,
      className: classes.buttonProgress,
      color: color
    });
  }
  return null;
};
const styles = () => ({
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
});
export default withStyles(styles)(ButtonLoadingAnimation);
ButtonLoadingAnimation.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  color: PropTypes.string
};
ButtonLoadingAnimation.defaultProps = {
  color: "secondary"
};